import { CardElement } from "@stripe/react-stripe-js";

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "#000000",
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#495057",
      },
    },
    invalid: {
      iconColor: "#495057",
      color: "#ffc7ee",
    },
  },
};

const StripeCardField = ({ onChange }) => (
  <>
    <div className="FormRow border-1-E8E8E8 py-3 px-3 br-10">
      <CardElement options={CARD_OPTIONS} onChange={onChange} />
    </div>
  </>
);
export default StripeCardField;
